import { z } from 'zod';

export const SUPPORTED_LOCALES = ['vi', 'en', 'ko', 'zh', 'ja'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = 'vi';
export const FALLBACK_LOCALE: Locale = 'en';
export const DEFAULT_TIMEZONE = 'Asia/Ho_Chi_Minh';

export const LocaleSchema = z.enum(SUPPORTED_LOCALES);

/** Translatable text stored in DB JSON columns: at least one locale; render with pickText(). */
export const I18nText = z.partialRecord(LocaleSchema, z.string());
export type I18nText = z.infer<typeof I18nText>;

export function pickText(text: I18nText | null | undefined, locale: string, fallback = ''): string {
  if (!text) return fallback;
  const l = locale.slice(0, 2) as Locale;
  return (
    text[l] ?? text[FALLBACK_LOCALE] ?? text[DEFAULT_LOCALE] ?? Object.values(text)[0] ?? fallback
  );
}
